export const fetchSyllbus =async ({BeURL}) => {
    try {
        const res = await fetch(`${BeURL}/manage-syllabus`, {
            method: "GET",
            credentials: "include",
        });

        const data = await res.json();

        return data;
    } catch (err) {
        console.log("Fetch department error", err);
        return { success: false, message: err.message };
    }
}
